"use strict";

/* jshint -W098 */
angular.module("mean.databases").controller("DatabasesHoursController", [
  "$scope",
  "$http",
  "Global",
  "MeanUser",
  "userService",
  "builderService",
  "ngDialog",
  "toaster",
  "$filter",
  "Hours",
  "aceUtils",
  "timeService",
  "myCoordinates",
  "ProjectHours",
  function (
    $scope,
    $http,
    Global,
    MeanUser,
    userService,
    builderService,
    ngDialog,
    toaster,
    $filter,
    Hours,
    aceUtils,
    timeService,
    myCoordinates,
    ProjectHours
  ) {
    $scope.global = Global;
    $scope.package = {
      name: "contacts",
    };

    $scope.sortType = ["user.username", "date"];
    $scope.sortReverse = false;
    $scope.itemDetails = {};

    $scope.user = MeanUser.user;

    var company = userService.getCompanyCode($scope.user.username);
    var trade_code = userService.getTradeCode($scope.user.username);

    userService.getUsers($scope.user.trade[0], company).then(function (result) {
      $scope.users = result;
    });

    userService
      .getMainAccount($scope.user.username)
      .then(function (main_account) {
        $scope.main_account = main_account;
      });

    $scope.typical = null;

    timeService
      .getStandardHours($scope.user.trade[0], $scope.user.contractor_code)
      .then(function (typical) {
        $scope.typical = typical;
      });

    $scope.editTimeDetails = function (item) {
      $scope.itemDetails = item;
    };

    $scope.modifyTimeDetails = function (item) {
      if (item._id) {
        Hours.query({ type: "ById", _id: item._id }, function (hourdb) {
          if (hourdb.length !== 1) {
            toaster.pop(
              "error",
              "Database Error",
              "Cannot update this record."
            );
            return;
          }

          var orig_time = hourdb[0];

          myCoordinates.get().then(function (coords) {
            if (item.clock_in && orig_time.clock_in) {
              if (
                !moment(item.clock_in.time).isSame(orig_time.clock_in.time) ||
                !moment(item.date).isSame(orig_time.clock_in.time, "day")
              ) {
                var set_time = moment(item.date);
                var hour = moment(item.clock_in.time).hour();
                var minute = moment(item.clock_in.time).minute();
                //var second = moment(item.clock_in.time).second();
                set_time.hour(hour);
                set_time.minute(minute);
                set_time.second(0);
                item.clock_in = {
                  time: set_time,
                  code: "O",
                  location: {
                    lat: coords.lat,
                    lon: coords.lon,
                  },
                  ip: coords.ip,
                };
              }
            }
            if (item.clock_out && orig_time.clock_out) {
              if (
                !moment(item.clock_out.time).isSame(orig_time.clock_out.time) ||
                !moment(item.date).isSame(orig_time.clock_out.time, "day")
              ) {
                var set_time = moment(item.date);
                var hour = moment(item.clock_out.time).hour();
                var minute = moment(item.clock_out.time).minute();
                //var second = moment(item.clock_out.time).second();
                set_time.hour(hour);
                set_time.minute(minute);
                set_time.second(0);
                item.clock_out = {
                  time: set_time,
                  code: "O",
                  location: {
                    lat: coords.lat,
                    lon: coords.lon,
                  },
                  ip: coords.ip,
                };
              }
            }
            if (item.lunch_start && orig_time.lunch_start) {
              if (
                !moment(item.lunch_start.time).isSame(
                  orig_time.lunch_start.time
                ) ||
                !moment(item.date).isSame(orig_time.lunch_start.time, "day")
              ) {
                var set_time = moment(item.date);
                var hour = moment(item.lunch_start.time).hour();
                var minute = moment(item.lunch_start.time).minute();
                //var second = moment(item.lunch_start.time).second();
                set_time.hour(hour);
                set_time.minute(minute);
                set_time.second(0);
                item.lunch_start = {
                  time: set_time,
                  code: "O",
                  location: {
                    lat: coords.lat,
                    lon: coords.lon,
                  },
                  ip: coords.ip,
                };
              }
            }
            if (item.lunch_end && orig_time.lunch_end) {
              if (
                !moment(item.lunch_end.time).isSame(orig_time.lunch_end.time) ||
                !moment(item.date).isSame(orig_time.lunch_end.time, "day")
              ) {
                var set_time = moment(item.date);
                var hour = moment(item.lunch_end.time).hour();
                var minute = moment(item.lunch_end.time).minute();
                //var second = moment(item.lunch_end.time).second();
                set_time.hour(hour);
                set_time.minute(minute);
                set_time.second(0);
                item.lunch_end = {
                  time: set_time,
                  code: "O",
                  location: {
                    lat: coords.lat,
                    lon: coords.lon,
                  },
                  ip: coords.ip,
                };
              }
            }

            $scope.updateClockRecord(item);
          });
        });
      } else {
        myCoordinates.get().then(function (coords) {
          var user = $filter("filter")(
            $scope.users,
            { username: item.user.username },
            true
          );
          var set_time = moment(item.date);
          var hour = new Hours({
            user: user[0]._id,
            date: set_time,
            trade_code: trade_code,
            company_code: company,
          });

          if (item.clock_in) {
            var obj = $scope.getTimeDetails(item.clock_in.time);
            set_time.hour(obj.hour);
            set_time.minute(obj.minute);
            set_time.second(obj.second);
            hour.clock_in = {
              time: new Date(set_time),
              code: "O",
              location: {
                lat: coords.lat,
                lon: coords.lon,
              },
              ip: coords.ip,
            };
          }

          if (item.lunch_start) {
            var obj = $scope.getTimeDetails(item.lunch_start.time);
            set_time.hour(obj.hour);
            set_time.minute(obj.minute);
            set_time.second(obj.second);
            hour.lunch_start = {
              time: new Date(set_time),
              code: "O",
              location: {
                lat: coords.lat,
                lon: coords.lon,
              },
              ip: coords.ip,
            };
          }

          if (item.lunch_end) {
            var obj = $scope.getTimeDetails(item.lunch_end.time);
            set_time.hour(obj.hour);
            set_time.minute(obj.minute);
            set_time.second(obj.second);
            hour.lunch_end = {
              time: new Date(set_time),
              code: "O",
              location: {
                lat: coords.lat,
                lon: coords.lon,
              },
              ip: coords.ip,
            };
          }

          if (item.clock_out) {
            var obj = $scope.getTimeDetails(item.clock_out.time);
            set_time.hour(obj.hour);
            set_time.minute(obj.minute);
            set_time.second(obj.second);
            hour.clock_out = {
              time: new Date(set_time),
              code: "O",
              location: {
                lat: coords.lat,
                lon: coords.lon,
              },
              ip: coords.ip,
            };
          }

          var idx = $scope.times.indexOf(item);
          var logged_hours = item.logged_hours;
          hour.$save(
            function (time) {
              time.date = moment(time.date);

              if (time.clock_in)
                time.clock_in.time = moment(time.clock_in.time); //.format("h:mm:ss a");
              if (time.lunch_start)
                time.lunch_start.time = moment(time.lunch_start.time);
              if (time.lunch_end)
                time.lunch_end.time = moment(time.lunch_end.time);
              if (time.clock_out)
                time.clock_out.time = moment(time.clock_out.time);

              var first = null;
              var second = null;

              if (time.lunch_start && time.clock_in)
                first = moment.duration(
                  time.lunch_start.time.diff(time.clock_in.time)
                );

              if (time.clock_out && time.lunch_end)
                second = moment.duration(
                  time.clock_out.time.diff(time.lunch_end.time)
                );

              if (first !== null && second !== null) {
                var final = moment.duration(first.add(second));
                time.total = moment
                  .utc(final.asMilliseconds())
                  .format("HH:mm:ss");
                time.seconds = parseFloat(final.asSeconds());
              } else {
                time.total = "N/A";
              }

              time.logged_hours = logged_hours;
              $scope.times.slice(idx, 1, time);
              toaster.pop("success", "Time Created");
            },
            function (error) {
              toaster.pop("error", "Time Not Created", error);
            }
          );
        });
      }
    };

    $scope.getTimeDetails = function (time) {
      var hour = moment(time).hour();
      var minute = moment(time).minute();
      var second = 0;

      return {
        hour: hour,
        minute: minute,
        second: second,
      };
    };

    $scope.updateClockRecord = function (item) {
      var idx = $scope.times.indexOf(item);
      var logged_hours = item.logged_hours;

      item.$update(
        function (time) {
          time.date = moment(time.date);

          if (time.clock_in) time.clock_in.time = moment(time.clock_in.time); //.format("h:mm:ss a");
          if (time.lunch_start)
            time.lunch_start.time = moment(time.lunch_start.time);
          if (time.lunch_end) time.lunch_end.time = moment(time.lunch_end.time);
          if (time.clock_out) time.clock_out.time = moment(time.clock_out.time);

          var first = null;
          var second = null;

          if (time.lunch_start && time.clock_in)
            first = moment.duration(
              time.lunch_start.time.diff(time.clock_in.time)
            );

          if (time.clock_out && time.lunch_end)
            second = moment.duration(
              time.clock_out.time.diff(time.lunch_end.time)
            );

          if (first !== null && second !== null) {
            var final = moment.duration(first.add(second));
            time.total = moment.utc(final.asMilliseconds()).format("HH:mm:ss");
            time.seconds = parseFloat(final.asSeconds());
          } else {
            time.total = "N/A";
          }

          time.logged_hours = logged_hours;

          $scope.times.slice(idx, 1, time);
          toaster.pop("success", "Time Updated");
        },
        function (error) {
          toaster.pop("error", "Time Update Error", error);
        }
      );
    };

    $scope.$on("hoursLoadEvent", function (event, data) {
      console.log("time load event");
      console.log(data);
      $scope.times = [];
      //var start_date = data.searchProp.start.clone();
      var end_date = moment(data.searchProp.end).startOf("day");
      var curr_date = moment(data.searchProp.start).startOf("day");

      ProjectHours.query(
        {
          trade: $scope.user.trade[0],
          company_code: $scope.user.contractor_code,
          start: data.searchProp.start,
          end: data.searchProp.end,
          username: data.searchProp.employee,
          main_username: $scope.main_account.username,
          populate: true,
        },
        function (projectHours) {
          console.log(projectHours);
          if (data.searchProp.employee === "All") {
            Hours.query(
              {
                trade_code: userService.getTradeCode($scope.user.username),
                company_code: $scope.user.contractor_code,
                type: "AllDateRange",
                start: data.searchProp.start,
                end: data.searchProp.end,
              },
              function (timesdb) {
                _.each(timesdb, function (time) {
                  time.date = moment(time.date);

                  if (time.clock_in)
                    time.clock_in.time = moment(time.clock_in.time); //.format("h:mm:ss a");
                  if (time.lunch_start)
                    time.lunch_start.time = moment(time.lunch_start.time);
                  if (time.lunch_end)
                    time.lunch_end.time = moment(time.lunch_end.time);
                  if (time.clock_out)
                    time.clock_out.time = moment(time.clock_out.time);

                  var first = null;
                  var second = null;

                  if (time.lunch_start && time.clock_in)
                    first = moment.duration(
                      time.lunch_start.time.diff(time.clock_in.time)
                    );

                  if (time.clock_out && time.lunch_end)
                    second = moment.duration(
                      time.clock_out.time.diff(time.lunch_end.time)
                    );

                  if (first !== null && second !== null) {
                    var final = moment.duration(first.add(second));
                    time.total = Math.round(final.asHours() * 100) / 100;
                    time.seconds = parseFloat(final.asSeconds());
                  } else if (time.clock_in && time.clock_out) {
                    var final = moment.duration(
                      time.clock_out.time.diff(time.clock_in.time)
                    );
                    time.total = Math.round(final.asHours() * 100) / 100;
                    time.seconds = parseFloat(final.asSeconds());
                  } else {
                    time.total = 0;
                  }
                });

                $scope.times = [];
                //we have to build the list mainly based off of clocked hours but
                //it can happen that there are project hours but no clocked so we
                //will iterate by date and check that way.
                var created_records = [];
                while (curr_date.diff(end_date) <= 0) {
                  var pHours = _.remove(projectHours, function (pHour) {
                    return moment(pHour.date).isSame(moment(curr_date), "day");
                  });
                  var cHours = _.remove(timesdb, function (cHour) {
                    return moment(cHour.date).isSame(moment(curr_date), "day");
                  });

                  //build the table off of the clocked hours first
                  _.each(cHours, function (hour) {
                    if (hour.user) {
                      if (!hour.logged_hours) hour.logged_hours = 0;
                      _.each(pHours, function (item) {
                        if (hour.user.username === item.username) {
                          hour.logged_hours += item.hours;
                        }
                      });
                      $scope.times.push(hour);
                    } else {
                      console.log("no user information in this record!!!!");
                    }
                  });

                  //var created_records = [];
                  _.each(pHours, function (hour) {
                    var found = false;
                    for (var i = 0; i < $scope.times.length; i++) {
                      if (hour.username === $scope.times[i].user.username) {
                        if (
                          moment(hour.date).isSame(
                            moment($scope.times[i].date),
                            "day"
                          )
                        ) {
                          found = true;
                          break;
                        }
                      }
                    }

                    if (!found) {
                      var find = $filter("filter")(
                        created_records,
                        { username: hour.username },
                        true
                      );

                      if (find.length === 0) {
                        $scope.times.push({
                          user: {
                            username: hour.username,
                            name: hour.name,
                          },
                          date: moment(curr_date),
                          total: 0,
                          logged_hours: hour.hours,
                        });
                        created_records.push({
                          username: hour.username,
                          index: $scope.times.length - 1,
                        });
                      } else {
                        //if we create a record, we want to check to see if
                        //there are more projectHours that we need to accumulate
                        //logged hours for.  This is only for the case where a
                        //user has multiple projectHours but no clock Hours.
                        //var find = $filter('filter')(created_records, {'username': hour.username}, true);
                        //if(find && find.length === 1) {
                        $scope.times[find[0].index].logged_hours += hour.hours;
                        //$scope.times[i].logged_hours += hour.hours
                      }
                    }
                  });
                  console.log("checking");
                  curr_date.add(1, "days");
                }

                _.each($scope.times, function (item) {
                  item.over = item.logged_hours - item.total;
                });
              }
            );
          } else {
            var user = $filter("filter")(
              $scope.users,
              { username: data.searchProp.employee },
              true
            );

            if (user.length !== 1) {
              toaster.pop(
                "error",
                "User Error",
                "Not able to find selected user.  Contact Admin"
              );
            }

            Hours.query(
              {
                trade_code: userService.getTradeCode($scope.user.username),
                company_code: $scope.user.contractor_code,
                user: user[0]._id,
                type: "UserDateRange",
                start: data.searchProp.start,
                end: data.searchProp.end,
              },
              function (timesdb) {
                _.each(timesdb, function (time) {
                  time.date = moment(time.date);

                  if (time.clock_in)
                    time.clock_in.time = moment(time.clock_in.time); //.format("h:mm:ss a");
                  if (time.lunch_start)
                    time.lunch_start.time = moment(time.lunch_start.time);
                  if (time.lunch_end)
                    time.lunch_end.time = moment(time.lunch_end.time);
                  if (time.clock_out)
                    time.clock_out.time = moment(time.clock_out.time);

                  var first = null;
                  var second = null;

                  if (time.lunch_start && time.clock_in)
                    first = moment.duration(
                      time.lunch_start.time.diff(time.clock_in.time)
                    );

                  if (time.clock_out && time.lunch_end)
                    second = moment.duration(
                      time.clock_out.time.diff(time.lunch_end.time)
                    );

                  if (first !== null && second !== null) {
                    var final = moment.duration(first.add(second));
                    time.total = Math.round(final.asHours() * 100) / 100;
                    time.seconds = parseFloat(final.asSeconds());
                  } else {
                    time.total = 0;
                  }
                });

                $scope.times = [];
                //we have to build the list mainly based off of clocked hours but
                //it can happen that there are project hours but no clocked so we
                //will iterate by date and check that way.
                while (curr_date.diff(end_date) <= 0) {
                  var pHours = _.remove(projectHours, function (pHour) {
                    return moment(pHour.date).isSame(moment(curr_date), "day");
                  });
                  var cHours = _.remove(timesdb, function (cHour) {
                    return moment(cHour.date).isSame(moment(curr_date), "day");
                  });

                  //build the table off of the clocked hours first
                  _.each(cHours, function (hour) {
                    if (hour.user) {
                      if (!hour.logged_hours) hour.logged_hours = 0;
                      _.each(pHours, function (item) {
                        if (hour.user.username === item.username) {
                          hour.logged_hours += item.hours;
                        }
                      });
                      $scope.times.push(hour);
                    } else {
                      console.log("no user information in this record!");
                    }
                  });

                  var created_records = [];
                  _.each(pHours, function (hour) {
                    var found = false;
                    for (var i = 0; i < $scope.times.length; i++) {
                      if (hour.username === $scope.times[i].user.username) {
                        if (
                          moment(hour.date).isSame(
                            moment($scope.times[i].date),
                            "day"
                          )
                        ) {
                          found = true;
                          break;
                        }
                      }
                    }

                    if (!found) {
                      var find = $filter("filter")(
                        created_records,
                        { username: hour.username },
                        true
                      );

                      if (find.length === 0) {
                        $scope.times.push({
                          user: {
                            username: hour.username,
                            name: hour.name,
                          },
                          date: moment(curr_date),
                          total: 0,
                          logged_hours: hour.hours,
                        });
                        created_records.push({
                          username: hour.username,
                          index: $scope.times.length - 1,
                        });
                      } else {
                        //if we create a record, we want to check to see if
                        //there are more projectHours that we need to accumulate
                        //logged hours for.  This is only for the case where a
                        //user has multiple projectHours but no clock Hours.
                        //var find = $filter('filter')(created_records, {'username': hour.username}, true);
                        //if(find && find.length === 1) {
                        $scope.times[find[0].index].logged_hours += hour.hours;
                        //$scope.times[i].logged_hours += hour.hours
                      }
                    }
                  });
                  console.log("checking");
                  curr_date.add(1, "days");
                }

                _.each($scope.times, function (item) {
                  item.over = item.logged_hours - item.total;
                });
              }
            );
          }
        }
      );
    });

    $scope.createTimeOperation = function () {
      $scope.returnedOptions = {
        user: $scope.$parent.selectedEmployee,
        hours: {
          clock_in: {
            time: moment($scope.typical.clock_in),
          },
          lunch_start: {
            time: moment($scope.typical.lunch_start),
          },
          lunch_end: {
            time: moment($scope.typical.lunch_end),
          },
          clock_out: {
            time: moment($scope.typical.clock_out),
          },
        },
        date: moment(),
      };

      ngDialog
        .openConfirm({
          template: "databases/views/tmpl/databases-new-time.html",
          scope: $scope,
          className: "ngdialog-theme-default",
        })
        .then(
          function (value) {
            if ($scope.returnedOptions.user.username === "All") {
              toaster.pop(
                "error",
                "User Selection Error",
                "You must pick a user"
              );
              return;
            }

            var start = new Date($scope.returnedOptions.date);
            start.setHours(0);
            start.setMinutes(0);
            start.setSeconds(0);
            var end = new Date($scope.returnedOptions.date);
            end.setHours(23);
            end.setMinutes(59);
            end.setSeconds(59);

            if ($scope.typical.mandatory_lunch) {
              var lunch_start = moment(
                $scope.returnedOptions.hours.lunch_start.time
              );
              var lunch_end = moment(
                $scope.returnedOptions.hours.lunch_end.time
              );
              var time = moment.duration(lunch_end.diff(lunch_start));
              if (time.minutes() < $scope.typical.lunch_minimum) {
                toaster.pop(
                  "error",
                  "Cannot Create User Hours",
                  "Mandatory lunch break minimum is " +
                    $scope.typical.lunch_minimum +
                    " minutes not " +
                    time.minutes() +
                    " minutes."
                );
                return;
              }
            }

            Hours.query(
              {
                trade_code: userService.getTradeCode($scope.user.username),
                company_code: $scope.user.contractor_code,
                type: "UserDateRange",
                start: start,
                end: end,
                user: $scope.returnedOptions.user._id,
              },
              function (timesdb) {
                if (timesdb.length !== 0) {
                  toaster.pop(
                    "error",
                    "Time Create Error",
                    "User already has an entry for this day"
                  );
                  return;
                }

                myCoordinates.get().then(function (coords) {
                  var clock_in = null;
                  var lunch_start = null;
                  var lunch_end = null;
                  var clock_out = null;
                  var timestamp = null;

                  if ($scope.returnedOptions.hours.clock_in.time) {
                    timestamp = $scope.setTimestamp(
                      $scope.returnedOptions.date,
                      $scope.returnedOptions.hours.clock_in.time
                    );
                    clock_in = {
                      time: timestamp,
                      code: "O",
                      location: {
                        lat: coords.lat,
                        lon: coords.lon,
                      },
                      ip: coords.ip,
                    };
                  }

                  if ($scope.returnedOptions.hours.lunch_start.time) {
                    timestamp = $scope.setTimestamp(
                      $scope.returnedOptions.date,
                      $scope.returnedOptions.hours.lunch_start.time
                    );
                    lunch_start = {
                      time: timestamp,
                      code: "O",
                      location: {
                        lat: coords.lat,
                        lon: coords.lon,
                      },
                      ip: coords.ip,
                    };
                  }

                  if ($scope.returnedOptions.hours.lunch_end.time) {
                    timestamp = $scope.setTimestamp(
                      $scope.returnedOptions.date,
                      $scope.returnedOptions.hours.lunch_end.time
                    );
                    lunch_end = {
                      time: timestamp,
                      code: "O",
                      location: {
                        lat: coords.lat,
                        lon: coords.lon,
                      },
                      ip: coords.ip,
                    };
                  }

                  if ($scope.returnedOptions.hours.clock_out.time) {
                    timestamp = $scope.setTimestamp(
                      $scope.returnedOptions.date,
                      $scope.returnedOptions.hours.clock_out.time
                    );
                    clock_out = {
                      time: timestamp,
                      code: "O",
                      location: {
                        lat: coords.lat,
                        lon: coords.lon,
                      },
                      ip: coords.ip,
                    };
                  }

                  var date_timestamp = $scope.setTimestamp(
                    $scope.returnedOptions.date,
                    $scope.returnedOptions.hours.clock_in.time
                  );

                  var hour = new Hours({
                    user: $scope.returnedOptions.user._id,
                    date: date_timestamp,
                    trade_code: trade_code,
                    company_code: company,
                    clock_in: clock_in,
                    lunch_start: lunch_start,
                    lunch_end: lunch_end,
                    clock_out: clock_out,
                  });

                  hour.$save(
                    function (success) {
                      toaster.pop("success", "Time Created");
                    },
                    function (error) {
                      toaster.pop("error", "Time Not Created", error);
                    }
                  );
                });
              }
            );
          },
          function (value) {
            //Do something
            //$scope.new_extra = false;
            console.log("in the do something section");
          }
        );
    };

    $scope.setTimestamp = function (date, time) {
      var ret_val = new Date(date);
      time = moment(time);
      ret_val.setHours(time.hours());
      ret_val.setMinutes(time.minutes());
      ret_val.setSeconds(time.seconds());

      return ret_val;
    };

    $scope.removeTime = function (item) {
      if (!item._id) {
        toaster.pop(
          "error",
          "Not A Time Record",
          "This entry is only logged hours."
        );
        return;
      }

      var logged_hours = item.logged_hours;
      item.$delete(
        function (success) {
          toaster.pop("success", "Time DB Updated", "Removed from database");
          var idx = $scope.times.indexOf(item);
          if (idx === -1) {
            toaster.pop(
              "warning",
              "Invoice Not Found",
              "Could not determine proper time from list.  Please resubmit query to refresh the list."
            );
          } else {
            if (logged_hours && logged_hours > 0) {
              success.logged_hours = logged_hours;
              $scope.times.splice(idx, 1, success);
            } else {
              $scope.times.splice(idx, 1);
            }
          }
        },
        function (error) {
          toaster.pop("error", "Time DB Error", error);
        }
      );
    };

    $scope.removeTimeOperation = function (item) {
      ngDialog
        .openConfirm({
          template:
            "<h2>Delete Time Card Data</h2>" +
            "<p>This operation will delete time card data from the system</p>" +
            "<p>Are you sure you want to continue? </p>" +
            "<div>" +
            '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
            '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
            "</button></div>",
          plain: true,
          className: "ngdialog-theme-default",
        })
        .then(
          function (value) {
            // perform delete operation
            $scope.removeTime(item);
          },
          function (value) {
            //Do something
            console.log(
              "in the do something section of removeInvoiceOperation"
            );
          }
        );
    };

    $scope.addMissingHours = function () {
      console.log("addMissingHours");
      $http({
        method: "GET",
        url: "/api/databases/filltime",
        params: {
          trade: $scope.user.trade[0],
          company_code: $scope.user.contractor_code,
          start: $scope.$parent.startDate,
          end: $scope.$parent.endDate,
        },
      }).then(
        function (response) {
          console.log(response);
        },
        function (error) {
          toaster.pop("error", "Time DB Error", error);
        }
      );
    };
  },
]);



// WEBPACK FOOTER //
// ./packages/custom/databases/public/controllers/database-hours.js